export default {
  presenter: 'dobsovic',
  title: 'Ako učiť dieťa zodpovednosti?',
  subtitle: 'Zodpovednosť za dieťa versus zodpovednosť voči dieťaťu',
  text: `
Zodpovednosť dieťaťa býva veľkou témou. Trápia sa ňou rodičia aj učitelia hľadajú všemožné cesty a spôsoby, ako dieťa motivovať a viesť k tomu, aby sa zodpovedne stavalo k svojim povinnostiam či už doma alebo v škole. Neraz majú rôzne “výchovné” zásahy negatívne účinky a podobajú sa skôr súboju, než spolupráci.
Téma zodpovednosti, a ako ju budovať v malom človeku tak, aby s ňou doslova rástol a stala sa súčasťou jeho postojov a hodnotového systému bude hlavným predmetom mojej prednášky – diskusie.

Psychológ - psychoterapeut, socioterapeut, člen Inštitútu psychoterapie a socioterapie, facilitátor výcvikových programov, tréningov pre manažérov a encounterových skupín pre laickú aj odbornú verejnosť. Autor populárno-náučnej knihy "Naučte sa riešiť konflikty" a viacerých odborných aj populárnych článkov.
  `,
}



// WEBPACK FOOTER //
// ./src/content/vychovakzivotu/data/presentations/p01_ako_ucit_dieta.js